module.exports = __webpack_public_path__ + "media/images/athletes/4347-5a27f3bfad489049acb54c03eb960ac4.png";